import type { DeepRequired } from '../fixtures.types'

const providerStatementRow: DeepRequired<ProviderStatementRow> = {
  __typename: 'ProviderStatementRow',
  id: 'TEST_ID',
  advisor_name: null,
  agency_code: null,
  client_names: [],
  completion_date: null,
  confidence_score: null,
  created_at: null,
  created_by: null,
  initial_commission: null,
  lender: null,
  loan_amount: null,
  match_confidence: null,
  matches: [],
  payment_date: null,
  payment_direction: null,
  policy_number: null,
  premium_amount: null,
  premium_frequency: null,
  proc_fee: null,
  provider_statement_id: null,
  reconciled_at: null,
  reconciled_by: null,
  reconciled_status: null,
  renewal_commission: null,
  updated_at: null,
  updated_by: null,
}

export default providerStatementRow
